import React, {useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import {SignupFeatures} from '../../components/signup-features';
import {SignupForm} from '../../components/signup-form';
import {Grid} from '../../components/layout';
import {SignupFormData} from '../../types/signup';
import {OrganizationContext} from '../../contexts/organization.provider';
import {AccountRegistrationContext} from '../../contexts/account-registration.provider';
import {useAuth} from '../../contexts/auth.provider';
import {storePendingAccount} from '../../utils';

export const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const {searchOrganizations} = useContext(OrganizationContext);
  const {registerByEmail} = useContext(AccountRegistrationContext);
  const {updateUser} = useAuth();

  const handleSubmit = async (values: SignupFormData, actions: any): Promise<void> => {
    try {
      try {
        await searchOrganizations(values.portalUrl);
        actions.setFieldError('portalUrl', 'Portal URL not available. Please choose a different one.');
        return;
      } catch (error: any) {
        console.log('Subdomain available, proceeding with registration');
      }

      const registrationResult = await registerByEmail({
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        status: 'ACTIVE',
      });

      if (!registrationResult.data) {
        throw new Error(registrationResult.error || 'Account registration failed');
      }

      const accountData = {
        accountId: registrationResult.data.id,
        email: values.email,
        organizationName: values.businessName,
        portalSubdomain: values.portalUrl,
        firstName: values.firstName,
        lastName: values.lastName,
        isVerified: false,
      };

      storePendingAccount(accountData);

      updateUser({
        id: registrationResult.data.id,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        isVerified: false,
      });

      navigate('/verify-email', {
        state: {
          email: values.email,
          accountId: registrationResult.data.id,
        },
      });
    } catch (error: any) {
      console.error('Signup failed:', error);
      if (error.message.includes('email')) {
        actions.setFieldError('email', error.message);
      } else {
        actions.setStatus(error.message);
      }
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Grid cols={{sm: 1, lg: 2}}>
      <SignupFeatures />
      <SignupForm onSubmit={handleSubmit} />
    </Grid>
  );
};
